import { IResultData } from "@/domain/entities/shared/result";
import {
  ICustomCode,
  ICustomCodeCollection,
} from "@/domain/entities/system/customCode.types";
import { useSystemStore } from "@/stores/systemStore";
import { CustomCodeGroup } from "@/types";
import { ref } from "vue";

interface IUseGetReportReasonseParams {
  onSuccess?: (
    result: IResultData<ICustomCodeCollection>,
    ...params: any
  ) => void;
  onError?: (
    result: IResultData<ICustomCodeCollection>,
    ...params: any
  ) => void;
}

export const useGetReportReasons = ({
  onSuccess,
  onError,
}: IUseGetReportReasonseParams) => {
  const systemStore = useSystemStore();

  const reportReasons = ref<ICustomCode[]>([]);

  const fetchReportReasons = async () => {
    const reportReasonsResult = await systemStore.getCustomCodes(
      CustomCodeGroup.VOR
    );

    if (!reportReasonsResult.isSuccess) {
      onError && onError(reportReasonsResult);
      return;
    }

    reportReasons.value = reportReasonsResult.data?.customCodes ?? [];
    onSuccess && onSuccess(reportReasonsResult);
  };

  return {
    reportReasons,
    fetchReportReasons,
  };
};
